module.exports = __webpack_public_path__ + "static/media/icon-user.1d12527c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-user.svg
// module id = 1611
// module chunks = 0